import { Popup as AkPopup, type PopupProps as AkPopupProps } from '@atlaskit/popup';

import type {
	ChoreographedComponentProps,
	ChoreographerMessageTypes,
	ToggleableChoreographerUtilities,
} from '../../types';
import { wrapToggleableComponentForChoreographer } from '../utils';

export const Popup: {
	({
		shouldBeChoreographed,
		withChoreographedToggle,
		...props
	}: (AkPopupProps & ToggleableChoreographerUtilities) &
		Partial<ChoreographedComponentProps> & {
			messageType?: ChoreographerMessageTypes;
		}): React.JSX.Element;
	displayName: string;
} = wrapToggleableComponentForChoreographer<AkPopupProps>(AkPopup, 'isOpen');
